import { render, staticRenderFns } from "./user-group-freight-price-editor.vue?vue&type=template&id=6ef67916&scoped=true&"
import script from "./user-group-freight-price-editor.vue?vue&type=script&lang=ts&"
export * from "./user-group-freight-price-editor.vue?vue&type=script&lang=ts&"
import style0 from "./user-group-freight-price-editor.vue?vue&type=style&index=0&id=6ef67916&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef67916",
  null
  
)

export default component.exports